export const filterMessage = (chats, action) => {
  let chat = chats.filter((chat) => chat._id.toString() === action.payload.roomId)
  return chat[0].messages.filter((msg) => msg._id.toString() === action.payload.msgId)[0]
};